import { Controller } from "@hotwired/stimulus";
import { displayFilePreview, fileDropped, manageProfileDragHover } from "../profiles/profile_file_upload";
import { DEFAULT_MAX_FILE_SIZE } from "../components/dropzone";
import { flashAlert } from "../components/flash_alert";

const MAX_BYTES_SIZE = DEFAULT_MAX_FILE_SIZE * 1024 * 1024;

export default class extends Controller {
  static targets = ["fileInput", "dropArea", "noFileImage"];

  fileUploaded() {
    const fileBytesSize = this.fileInputTarget.files[0].size;
    if (fileBytesSize > MAX_BYTES_SIZE) {
      this.fileInputTarget.value = null;
      flashAlert(`Le fichier ne doit pas dépasser ${DEFAULT_MAX_FILE_SIZE} MB`, "alert");
      return;
    }

    displayFilePreview(this.element, this.fileInputTarget);
  }

  fileDropped(e) {
    fileDropped(e, this.fileInputTarget, this.dropAreaTarget, this.noFileImageTarget);
  }

  dropAreaOver() {
    manageProfileDragHover(this.dropAreaTarget, this.noFileImageTarget, "hover");
  }

  dropAreaLeave() {
    manageProfileDragHover(this.dropAreaTarget, this.noFileImageTarget, "");
  }

  preventEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }
}
